import './SubStepIndicator.scss';

export { default } from './SubStepIndicator';
